<form nz-form nzLayout="vertical" [formGroup]="form" (ngSubmit)="submit()">
  <p class="text-gray-600 mb-4">
    {{ 'servicePackages.confirm.cancelDescription' | translate }}
  </p>

  <!-- Which till day the reversal lands on. This modal only opens for a sale
       on an earlier day, so the choice is always meaningful here. -->
  <nz-form-item>
    <nz-form-label>{{ 'servicePackages.refund.settlementLabel' | translate }}</nz-form-label>
    <nz-form-control>
      <nz-radio-group formControlName="settlementDay">
        <label nz-radio nzValue="TODAY">
          {{ 'servicePackages.refund.settlement.today' | translate }}
          <span class="text-gray-500"> — {{ today | date : 'dd/MM/yyyy' }}</span>
        </label>
        <label nz-radio nzValue="SALE_DATE">
          {{ 'servicePackages.refund.settlement.saleDate' | translate }}
          <span class="text-gray-500"> — {{ saleDate | date : 'dd/MM/yyyy' }}</span>
        </label>
      </nz-radio-group>
      <div class="text-xs text-gray-500 mt-1">
        {{ 'servicePackages.refund.settlementHint' | translate }}
      </div>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label>{{ 'servicePackages.refund.commentLabel' | translate }}</nz-form-label>
    <nz-form-control>
      <textarea
        nz-input
        rows="2"
        formControlName="reason"
        [placeholder]="'servicePackages.refund.commentPlaceholder' | translate"
      ></textarea>
    </nz-form-control>
  </nz-form-item>

  <div class="flex justify-end gap-2 mt-4">
    <button type="button" nz-button nzType="default" [disabled]="submitting()" (click)="cancel()">
      {{ 'buttons.cancel' | translate }}
    </button>
    <button type="submit" nz-button nzType="primary" nzDanger [nzLoading]="submitting()">
      {{ 'servicePackages.refund.confirm' | translate }}
    </button>
  </div>
</form>
